import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';

export const isEmptyConversation = (conversationId?: string): boolean =>
	conversationId === EMPTY_CONVERSATION_ID || conversationId === undefined;
